import { MarginsResponse } from "../../../../api/useGetMargins";
import { getCurrencyValue } from "../../../CallAlertsAuxWindow/auxUtils";

export const buildEquity = (marginSummary: MarginsResponse) => {
  const {
    cashMarketValue,
    marginMarketValue,
    shortMarketValue,
    marginEquity,
    netLiquidity: totalEquity, // Rename to match Ascend
  } = marginSummary;

  return [
    {
      label: "Cash Market Value",
      value: getCurrencyValue(cashMarketValue),
      isNumeric: true,
    },
    {
      label: "Margin Market Value",
      value: getCurrencyValue(marginMarketValue),
      isNumeric: true,
    },
    {
      label: "Short Market Value",
      value: getCurrencyValue(shortMarketValue),
      isNumeric: true,
    },
    {
      label: "Margin Equity",
      value: getCurrencyValue(marginEquity),
      isNumeric: true,
    },
    {
      label: "Net Liquidating Value",
      value: getCurrencyValue(totalEquity),
      isNumeric: true,
    },
  ];
};
